

























































import { tPropsToSearch, tTableColumns } from 'teip-components';
import {
  liquidationSettlementParams
} from '@/store/interfaces/settlements';
import FormatDate from '@/util/classes/datesFormat';
import { navLink } from '@/ts/navegationLinks';
import settlements from '@/store/types/settlements';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
const dateFormat = new FormatDate();

export default Vue.extend({
  name: 'SettlmentTable',
  data: () => ({
    navlink: [
      {
        name: 'Reportes',
        active: false,
        to: '/liquidations-report',
      },
      {
        name: 'Liquidaciones',
        active: true,
      }
    ] as navLink[],
    tableColumns: [
      {
        prop: 'company.business_name',
        label: 'Compañía',
        minWidth: 280,
        sortable: true,
      },
      {
        prop: 'rate',
        label: 'Tasa',
        minWidth: 280,
        sortable: true,
      },
      {
        prop: 'period_from',
        label: 'Periodo desde',
        minWidth: 280,
        sortable: true,
        formatter: (row: liquidationSettlementParams): string => {
          return dateFormat.formatDate(row.period_from);
        },
      },
      {
        prop: 'period_to',
        label: 'Periodo hasta',
        minWidth: 280,
        sortable: true,
        formatter: (row: liquidationSettlementParams): string => {
          return dateFormat.formatDate(row.period_to);
        },
      },
      {
        prop: 'transactions_count',
        label: 'Transacciones',
        minWidth: 280,
        sortable: true,
      },
      {
        prop: 'subtotal_cents',
        label: 'Subtotal',
        minWidth: 280,
        sortable: true,
        slotName: 'subtotal_cents',
      },
      {
        prop: 'tip_cents',
        label: 'Propina',
        minWidth: 280,
        sortable: true,
        slotName: 'tip_cents',
      },
      {
        prop: 'discount_cents',
        label: 'Descuento',
        minWidth: 280,
        sortable: true,
        slotName: 'discount_cents',
      },
      {
        prop: 'subtotal_without_taxes_cents',
        label: 'Comisionable',
        minWidth: 280,
        sortable: true,
        slotName: 'subtotal_without_taxes_cents',
      },
      {
        prop: 'stated_taxes_cents',
        label: 'Impuesto',
        minWidth: 280,
        sortable: true,
        slotName: 'stated_taxes_cents',
      },
      {
        prop: 'stated_commission_cents',
        label: 'Comisión',
        minWidth: 280,
        sortable: true,
        slotName: 'stated_commission_cents',
      },
      {
        prop: 'total',
        label: 'Total',
        minWidth: 280,
        sortable: true,
        slotName: 'total_cents',
      }
    ] as tTableColumns,
    liquidationSettlement: {} as liquidationSettlementParams,
    propsToSearch: [] as tPropsToSearch[],
  }),
  computed: {
    ...mapGetters({
      getLiquidationBySettlements: `settlementModule/${settlements.getters.GET_LIQUIDATIONS_BY_SETTLEMENTS}`,
    }),
  },
  methods: {
    ...mapActions({
      allLiquidationBySettlements: `settlementModule/${settlements.actions.LIQUIDATIONS_BY_SETTLEMENTS}`,
    }),
    rowSelect(row: liquidationSettlementParams): void {
      this.liquidationSettlement = row;
    },
  },
});
